<button type="button" class="open-tooltip-help" [ngClass]="{'open-tooltip-icon': tooltipType === 'icon', 'open-tooltip-both': tooltipType === 'both'}" (click)="openTooltip()" [title]="tooltipLabel">  
  <a *ngIf="tooltipType === 'link' || tooltipType === 'both'" mat-button color="primary" [innerHTML]="tooltipLabel"></a>
  <mat-icon *ngIf="tooltipType === 'icon' || tooltipType === 'both'" aria-hidden="false" aria-label="help icon" [ngClass]="tooltipIcon"></mat-icon>
</button>

<dialog class="open-tooltip-wrapper" [ngClass]="classes" #dialog (click)="backdropClicked($event)">
  <div class="open-tooltip-internal-wrapper">
    <button
      mat-button
      type="button"
      class="open-tooltip-close-button padding-none"
      (click)="closeTooltip()"
    >
      <mat-icon class="clear" aria-hidden="false" aria-label="close"></mat-icon>
    </button>
    <div class="open-tooltip" [innerHTML]="tooltipContent"></div>
  </div>
</dialog>

